import { render, staticRenderFns } from "./CommentImageAlert.vue?vue&type=template&id=3e0a2ff5&scoped=true&"
import script from "./CommentImageAlert.vue?vue&type=script&lang=js&"
export * from "./CommentImageAlert.vue?vue&type=script&lang=js&"
import style0 from "./CommentImageAlert.vue?vue&type=style&index=0&id=3e0a2ff5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0a2ff5",
  null
  
)

export default component.exports